import { StrictMode } from "react";
import GoogleRecaptcha from "@moovfinancial/common/utils/GoogleRecaptcha";
import { shouldEnableMocks } from "@moovfinancial/common/utils/env";
import { loadAfterTelemetry } from "@moovfinancial/common/utils/startTelemetry";
import { createRoot } from "react-dom/client";
import "./index.scss";

GoogleRecaptcha.init();

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");
const root = createRoot(container);

const initMocks = async () => {
  if (shouldEnableMocks()) {
    try {
      /**
       *  🔴🔴🔴
       *
       *  Yeah, I know dynamic imports are icky, but if we import these at the top of the file,
       *  they get bundled into the main bundle, pulling in a bunch of test code that we don't want, or need,
       *  causing weird issues when `setupTests.ts` ends up bundled into the build.
       *
       *  See: https://moovfinancial.slack.com/archives/C05RTT1UPNV/p1744245881544989?thread_ts=1744245860.978359&cid=C05RTT1UPNV
       *  And our tool to find import chains: `npm run find-import-chain {target path or string} {initial search path}`
       *
       *  🔴🔴🔴
       */
      const [{ initBrowserMocks }, { httpHandlers }] = await Promise.all([
        import("@moovfinancial/common/tests/mockBrowser"),
        import("tests/httpHandlers")
      ]);
      await initBrowserMocks(httpHandlers);
    } catch {
      // Silently continue if mocks fail to initialize
    }
  }
};

const renderApp = async () => {
  const { default: App } = await loadAfterTelemetry("dashboard", __APP_VERSION__, async () => {
    await initMocks();
    return import("./App");
  });

  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
};

void renderApp().catch((error: unknown) => {
  // eslint-disable-next-line no-console
  console.error("Failed to start dashboard", error);
});
